import { clearFromParent, updateOrbitTarget, visibleOffForModel } from '@/Engine/app';
import { ToolChest } from '@/Engine/ToolChest';
import { $ } from '@/Engine/state';
import { uploadModel } from '@/libs/loadModel';
import { markAllCollision, noMarkAllCollision } from '@/Engine/eventHandlers/libs/markCollision';
import { setAccessoryChildrenParent } from '@/Engine/eventHandlers/libs/shieldChildrenAccessoryParent';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { Object3D } from 'three';
import { accessoryFileName, mapComponentsToToolChest } from '@/Constants/glb';



export const onStoreUpdateHandler = async() => {
    if (!$.initConfigurator) return;
    const store = useStoreCaseConfiguration().$state;
    if (!store.blenderName) return;
    if ($.isProcessUpdate) {
        $.isNeedUpdate = true;
        return;
    }
    $.isProcessUpdate = true;
    let toolChest: ToolChest | null = null;
    let model;
    // условие если шкаф изменился
    if ($.toolChest?.blenderName && $.toolChest?.blenderName !== store.blenderName) {
        //TODO утечка когда $.toolChest?.blenderName !== store.blenderName при переключ пресетов
        // утечка большая как будто не очищаем полностью шкаф предыдущий
        $.modelCache?.destroy();
        clearFromParent();
    } else if ($.toolChest) {
        toolChest = $.toolChest;
    }

    if (toolChest) {
        toolChest.update(store);
    } else {
        model = await uploadModel(store.blenderName);
        visibleOffForModel(model as Object3D);
        toolChest = new ToolChest(store, model as Object3D);
        $.app.scene.add(toolChest.model);
        $.toolChest = toolChest;
        updateOrbitTarget();
        setAccessoryChildrenParent();
        $.render();
        await toolChest.uploadModels(mapComponentsToToolChest.get(toolChest.fileName));
        await toolChest.uploadModels(accessoryFileName);
        $.render();
    }
    noMarkAllCollision();
    markAllCollision();
    await toolChest.replaceModels();
    toolChest.addSectionsCNCToGroup();
    $.isProcessUpdate = false;
    if ($.isNeedUpdate) {
        $.isNeedUpdate = false;
        await onStoreUpdateHandler();
    }
    // const selectedCaseId=useStoreProjectStructure().selectedCaseId;
    // useStoreProjectStructure().setCaseCostById(selectedCaseId, getFinalCasePrice(selectedCaseId));
};

